import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import LoadingPopup from "../helpers/loading_component.js";
import SelectSearch from "react-select-search";
import { secretKey } from "../.././data";
import Select from "react-select";

const MySwal = withReactContent(Swal2);

const EditPSP = (props) => {
  const [value, setValue] = useState(props.client.praw_spr_pozew);
  const [loading, setLoading] = useState(false);
  const [lawyerOptions, setLawyerOptions] = useState([]);

  const editClient = async (e) => {
    if (validatePayment()) {
      setLoading(true);

      var body = {
        id: props.client.id,
        praw_spr_pozew: value,
      };

      await fetch("https://apidevkppp.ftpeople.pl/addPSPClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction(
        "Edytowano informację o prawniku sprawdzającym pozew",
        props.client.id
      );

      emailjs.init("user_7x2uGk2osoyVegzDMAi4G");
      var templateParams = {
        to:
          props.users.filter((el) => el.name === value).length > 0
            ? props.users.filter((el) => el.name === value)[0].mail
            : "m.bialas@kppp.pl",
        reply_to: "",
        content: `W sprawie o ID: ${
          props.client.id_old
        } (${props.client.petitioner.replaceAll(
          "  ",
          ""
        )}) zakończono ankietę do pozwu. Proszę o sprawdzenie.`,
        subject: `W sprawie o ID: ${props.client.id_old} zakończono ankietę do pozwu. Proszę o sprawdzenie.`,
        user_name: props.client.praw_pozew,
      };

      emailjs.send("KPPP", "template_h43760d", templateParams).then(
        function (response) {
          var templateParams = {
            to:
              props.users.filter(
                (el) => el.name === props.client.praw_spr_pozew
              ).length > 0
                ? props.users.filter(
                    (el) => el.name === props.client.praw_spr_pozew
                  )[0].mail
                : "m.bialas@kppp.pl",
            reply_to: "",
            content: `W sprawie o ID: ${
              props.client.id_old
            } (${props.client.petitioner.replaceAll(
              "  ",
              ""
            )}) zmieniono osobę sprawdzającą pozew.`,
            subject: `W sprawie o ID: ${props.client.id_old} zmieniono osobę sprawdzającą pozew.`,
            user_name: value,
          };

          emailjs.send("KPPP", "template_h43760d", templateParams).then(
            function (response) {
              MySwal.fire({
                icon: "success",
                title: "Edytowano",
                text: "sprawę",
              }).then(async (result) => {
                props.close();
              });
            },
            function (error) {
              MySwal.fire({
                icon: "success",
                title: "Edytowano",
                text: "sprawę",
              }).then(async (result) => {
                props.close();
              });
            }
          );
        },
        function (error) {
          MySwal.fire({
            icon: "success",
            title: "Edytowano",
            text: "sprawę",
          }).then(async (result) => {
            props.close();
          });
        }
      );
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validatePayment = (e) => {
    if (value.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const createYesNoOptions = (e) => {
    var statusOptions = [];
    statusOptions.push({ name: "TAK", value: "TAK" });
    statusOptions.push({ name: "NIE", value: "NIE" });
    statusOptions.push({ name: "Brak danych", value: "Brak danych" });

    return statusOptions;
  };

  const createLawyerOptions = (e) => {
    var bankOptions = [];
    bankOptions.push({ label: "brak danych", value: "brak danych" });
    if (+props.client.team === 0) {
      props.lawyersData.map((el) => {
        bankOptions.push({ label: el.name, value: el.name });
      });
    } else {
      props.lawyersData
        .filter((el) => el.team.includes(+props.client.team))
        .map((el) => {
          bankOptions.push({ label: el.name, value: el.name });
        });
    }

    return bankOptions;
  };

  useEffect(() => {
    setLawyerOptions(createLawyerOptions());
  }, []);

  return (
    <div className="mainContainerAddClient">
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div className="closeButtonAP">
            <button className="closeClientButton" onClick={props.close}>
              X
            </button>
          </div>

          <div className="sepAddC">Informacje do pozwu</div>

          <div className="inputBox">
            <div className="inputCol_3">
              <label>
                Prawnik sprawdzający pozew{" "}
                <span className="requiredStar">*</span>
              </label>
              <Select
                noOptionsMessage={() => "Brak danych"}
                placeholder={"Wybierz..."}
                isClearable={false}
                options={lawyerOptions}
                onChange={(e) => setValue(e.value)}
              />
            </div>
          </div>

          <div className="saveBoxAP">
            <button className="paymentMenuButton" onClick={editClient}>
              zapisz
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditPSP;
